import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { BookOpen, Video, ImageIcon, ClipboardList, Users, HandHeart, ArrowRight, GraduationCap } from "lucide-react";
import api from "@/lib/api";
import { PageHero } from "@/components/public/Shared";
import { formatDate } from "@/lib/helpers";
import { Button } from "@/components/ui/button";

const CATS = [
  { key: "Semua", label: "Semua", icon: GraduationCap },
  { key: "Artikel", label: "Artikel", icon: BookOpen },
  { key: "Video", label: "Video", icon: Video },
  { key: "Infografis", label: "Infografis", icon: ImageIcon },
  { key: "Kuis", label: "Kuis", icon: ClipboardList },
  { key: "Pemilih Pemula", label: "Pemilih Pemula", icon: Users },
  { key: "Pengawasan Partisipatif", label: "Pengawasan Partisipatif", icon: HandHeart },
];

export default function Edukasi() {
  const [items, setItems] = useState([]);
  const [cat, setCat] = useState("Semua");

  useEffect(() => {
    api.get(`/education${cat !== "Semua" ? `?category=${encodeURIComponent(cat)}` : ""}`).then((r) => setItems(r.data));
  }, [cat]);

  return (
    <div>
      <PageHero eyebrow="Literasi Demokrasi" title="Edukasi Pemilu"
        description="Pelajari pemilu, kepemiluan, dan pengawasan partisipatif melalui artikel, video, infografis, dan kuis interaktif.">
        <Link to="/kuis"><Button className="mt-6 bg-brandred hover:bg-brandred-700 text-white rounded-full px-7 h-11 font-semibold" data-testid="mulai-kuis-hero"><ClipboardList className="h-4 w-4 mr-2" /> Ikuti Kuis Pemilu</Button></Link>
      </PageHero>

      <div className="container-page py-10">
        <div className="flex flex-wrap gap-2 mb-8" data-testid="edu-filter">
          {CATS.map((c) => (
            <button key={c.key} onClick={() => c.key === "Kuis" ? null : setCat(c.key)}
              className={`inline-flex items-center gap-2 px-4 py-2 rounded-full text-sm font-semibold border transition-colors ${cat === c.key ? "bg-navy text-white border-navy" : "bg-white text-slate-600 border-slate-200 hover:border-navy"}`}>
              <c.icon className="h-4 w-4" /> {c.label}
            </button>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {items.map((e) => (
            <div key={e.id} className="bg-white border border-slate-200 rounded-xl overflow-hidden hover:shadow-lg transition-shadow flex flex-col">
              <div className="relative h-40 bg-slate-100">
                <img src={e.thumbnail} alt={e.title} className="h-full w-full object-cover" />
                <span className="absolute top-2 left-2 text-[10px] font-bold px-2 py-1 rounded-full bg-white text-navy">{e.category}</span>
              </div>
              <div className="p-4 flex flex-col flex-1">
                <h3 className="font-bold text-navy text-sm leading-snug line-clamp-2">{e.title}</h3>
                <p className="text-xs text-slate-500 mt-1.5 line-clamp-2 flex-1">{e.description}</p>
                <div className="text-[11px] text-slate-400 mt-3">{formatDate(e.date)}</div>
                <Link to={`/edukasi/${e.id}`} data-testid={`edu-${e.id}`} className="inline-flex items-center gap-1.5 text-sm font-bold text-brandred mt-2">
                  Pelajari <ArrowRight className="h-4 w-4" />
                </Link>
              </div>
            </div>
          ))}
        </div>
        {items.length === 0 && <div className="text-center py-16 text-slate-400">Belum ada materi untuk kategori ini.</div>}
      </div>
    </div>
  );
}
